import { Box, Chip, TableCell, Typography, styled } from "@mui/material"

const JustificationLabel = styled("span")(({ theme }) => ({
  color: "inherit",
  fontSize: theme.typography.pxToRem(12),
}))

interface LabJustificationCellProps {
  nbParticipantsWithProofs: number
}

const LabJustification = ({
  nbParticipantsWithProofs,
}: LabJustificationCellProps) => {
  if (nbParticipantsWithProofs <= 0) {
    return (
      <Box display="flex" alignItems="center" gap={0.5} color="text.disabled">
        <JustificationLabel>Aucun justificatif</JustificationLabel>
      </Box>
    )
  }
  return (
    <Box display="flex" alignItems="center" gap={0.5} color="success.main">
      <Chip
        label={
          <Typography fontWeight="bold" fontSize="inherit">
            {nbParticipantsWithProofs}
          </Typography>
        }
        color="success"
        variant="outlined"
        size="small"
      />
      <JustificationLabel>Justificatifs transmis</JustificationLabel>
    </Box>
  )
}

export const LabJustificationCell = (props: LabJustificationCellProps) => {
  return (
    <TableCell>
      <LabJustification {...props} />
    </TableCell>
  )
}
